/**
 * The model sometimes echoes tool names and JSON in the same stream as the natural-language answer.
 * Tool results are shown separately; strip trailing echoes from the assistant text.
 */
const TOOL_LINE_START = new Set<string>([
  'queryERPData',
  'searchTasks',
  'searchDocuments',
  'searchBySemanticQuery',
  'searchLinkedRecords',
  'openPage',
  'openFilteredList',
  'deepLinkToDocument',
  'navigateToList',
  'getOverdueItems',
  'getBlockers',
  'getPendingApprovals',
  'getTaskDependencies',
  'assignTask',
  'addComment',
  'submitForApproval',
  'summarizeSalesOrder',
  'summarizeWorkOrder',
  'summarizePurchaseOrder',
  'summarizeCustomerAccount',
  'summarizeSupplierAccount',
  'summarizeVATReturn',
  'summarizeTraceabilityChain',
  'summarizeDashboardModule',
  'getNextActions',
  'prepareActionDraft',
  'markOperationComplete',
]);

/**
 * Cut assistant text at the first line that is only a registered tool identifier (model echo).
 */
export function stripAssistantToolEchoFromModel(text: string): string {
  if (!text) return text;
  const lines = text.split(/\r?\n/);
  for (let i = 0; i < lines.length; i += 1) {
    const t = (lines[i] ?? '').trim();
    if (t && TOOL_LINE_START.has(t)) {
      return lines.slice(0, i).join('\n').trimEnd();
    }
  }
  return text;
}

/**
 * Removes [FACT] / [INFERENCE] / [RECOMMENDATION] scaffolding and normalizes spacing for display.
 */
export function polishAssistantReplyText(text: string): string {
  const stripped = stripAssistantToolEchoFromModel(text);
  if (!stripped) return '';
  const lines = stripped.split(/\r?\n/);
  const out: string[] = [];
  for (const line of lines) {
    const trimmed = line.trim();
    const m = trimmed.match(/^\[(FACT|INFERENCE|RECOMMENDATION)\]\s*(.*)$/i);
    if (!m) {
      out.push(line);
      continue;
    }
    let rest = (m[2] ?? '').trim();
    rest = rest.replace(/^[—\-–:]\s*/, '');
    if (rest.length > 0) out.push(rest);
  }
  return out
    .join('\n\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
